import { activityTypeOptions } from 'options';
import { createSelectFilterChip } from 'components/filters/createSelectFilterChip';

export const AllActivityTypesFilterChip = createSelectFilterChip(activityTypeOptions, { name: 'type' });
